import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=7b8fbd75&scoped=true"
import script from "./switch.vue?vue&type=script&lang=ts"
export * from "./switch.vue?vue&type=script&lang=ts"
import style0 from "./switch.vue?vue&type=style&index=0&id=7b8fbd75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8fbd75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8fbd75')) {
      api.createRecord('7b8fbd75', component.options)
    } else {
      api.reload('7b8fbd75', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=7b8fbd75&scoped=true", function () {
      api.rerender('7b8fbd75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/switch/switch.vue"
export default component.exports